import queryString from '../core/query-string'
/**
 *
 * @param {当前路由信息对象} $route
 * 返回hash对象
 */
export const parseHash = function () {
  let hash = location.hash
  if (hash == '') return {}
  // console.log('this.$route.hash', hash)
  hash = hash.substr(1, hash.length)
  hash = queryString.parse(hash, '&')
  // console.log('hash', hash);
  return hash
}

/**
 *
 * @param {当前hash信息， object类型}} hash
 */
export const stringifyHash = function (hash) {
  let result = ''
  const hashArr = []
  for (const key in hash) {
    if (hash[key] !== undefined) {
      hashArr.push(`${key}=${hash[key]}`)
    }
  }
  if (hashArr.length > 0) {
    result += '#'
    result += hashArr.join('&')
  }
  return result
}

export const updateHash = function (obj) {
  let hash = parseHash(location.hash)
  hash = {
    ...hash,
    ...obj,
    tm: new Date().getTime()
  }
  // console.log('update hash', hash)
  return stringifyHash(hash)
}

export const getUrlQuery = function (url = '') {
  return queryString.getQuery(url)
}
export const checkLimit = (to, from, next, privilege) => {
  if (privilege == 'y') {
    next({ path: '/card/view' })
  } else {
    next()
  }
}
